import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IDeleteUserPayload,
  IGetUserPayload,
  IUpdateUserPayload,
  IUserState,
} from "../../../interfaces/store/user-interfaces";

const initialState: IUserState = {
  user: null,
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
};

const _getUserStart = (
  state: IUserState,
  { payload }: PayloadAction<IGetUserPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getUserSuccess = (
  state: IUserState,
  { payload }: PayloadAction<any>
) => {
  state.user = payload.data;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getUserFailed = (
  state: IUserState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload.error;
  state.requestState = "error";
};

const _updateUserStart = (
  state: IUserState,
  { payload }: PayloadAction<IUpdateUserPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateUserSuccess = (
  state: IUserState,
  { payload }: PayloadAction<any>
) => {
  state.user = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _updateUserFailed = (
  state: IUserState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetUser = () => {
  return { ...initialState };
};

const _deleteUserStart = (
  state: IUserState,
  { payload }: PayloadAction<IDeleteUserPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "delete";
}

const _deleteUserSuccess = (
  state: IUserState,
  { payload }: PayloadAction<any>
) => {
  state.user = null;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _deleteUserFailed = (
  state: IUserState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUserStart: _getUserStart,
    getUserSuccess: _getUserSuccess,
    getUserFailed: _getUserFailed,
    updateUserStart: _updateUserStart,
    updateUserSuccess: _updateUserSuccess,
    updateUserFailed: _updateUserFailed,
    resetUser: _resetUser,
    deleteUserStart: _deleteUserStart,
    deleteUserSuccess: _deleteUserSuccess,
    deleteUserFailed: _deleteUserFailed,
  },
});

export const {
  getUserStart,
  getUserSuccess,
  getUserFailed,
  updateUserStart,
  updateUserSuccess,
  updateUserFailed,
  resetUser,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailed,
} = userSlice.actions;

export default userSlice.reducer;
